import { ReactNode } from "react";

import {
  FlexHeaderCell,
  FlexTableContainer,
  FlexTableHeader,
  ColumnConfig,
  TablePagination,
} from "@/components";

interface FlexTableProps {
  columns: ColumnConfig[];
  children: ReactNode;
  page: number;
  totalPages: number;
  onPageChange: (event: React.ChangeEvent<unknown>, page: number) => void; // 타입 수정
}

export const FlexTable = ({
  columns,
  children,
  page,
  totalPages,
  onPageChange,
}: FlexTableProps) => (
  <FlexTableContainer>
    <FlexTableHeader>
      {columns.map((column, index) => (
        <FlexHeaderCell
          key={index}
          width={column.width}
          flex={column.flex}
        >
          {column.label}
        </FlexHeaderCell>
      ))}
    </FlexTableHeader>
    {children}
    <TablePagination
      page={page}
      totalPages={totalPages}
      onPageChange={onPageChange}
    />
  </FlexTableContainer>
);
